import { Injectable } from '@angular/core';

import {
  CustomList
} from '../../../model/acs-project.model';
import { Observable, of } from 'rxjs';
import { ExpatClient } from '../../../../core/api/models/expat-client';
import { ExpatPricing } from '../../../../core/api/models/expat-pricing';
import { ExpatProject } from '../../../../core/api/models/expat-project';
import { delay } from 'rxjs/operators';
import { TokenResponse } from '../dto';
import { IAcsHttpService } from './acs-http-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AcsHttpServiceFake implements IAcsHttpService{

  public getCustomList(): Observable<CustomList> {
    return of({
      expatriation_countries: {
        fr: [
          {
            label: 'Afrique du Sud',
            alpha3: 'ZAF'
          },
          {
            label: 'Albanie',
            alpha3: 'ALB'
          },
          {
            label: 'Alg\u00e9rie',
            alpha3: 'DZA'
          },
          {
            label: 'Allemagne',
            alpha3: 'DEU'
          },
          {
            label: 'Andorre',
            alpha3: 'AND'
          },
          {
            label: 'Angola',
            alpha3: 'AGO'
          },
          {
            label: 'Antigua-et-Barbuda',
            alpha3: 'ATG'
          },
          {
            label: 'Arabie Saoudite',
            alpha3: 'SAU'
          },
          {
            label: 'Argentine',
            alpha3: 'ARG'
          },
          {
            label: 'Arm\u00e9nie',
            alpha3: 'ARM'
          },
          {
            label: 'Australie',
            alpha3: 'AUS'
          },
          {
            label: 'Autriche',
            alpha3: 'AUT'
          },
          {
            label: 'Azerba\u00efdjan',
            alpha3: 'AZE'
          },
          {
            label: 'Bahamas',
            alpha3: 'BHS'
          },
          {
            label: 'Bahre\u00efn',
            alpha3: 'BHR'
          },
          {
            label: 'Bangladesh',
            alpha3: 'BGD'
          },
          {
            label: 'Barbade',
            alpha3: 'BRB'
          },
          {
            label: 'Belgique',
            alpha3: 'BEL'
          },
          {
            label: 'Belize',
            alpha3: 'BLZ'
          },
          {
            label: 'Bhoutan',
            alpha3: 'BTN'
          },
          {
            label: 'Bi\u00e9lorussie',
            alpha3: 'BLR'
          },
          {
            label: 'Bolivie',
            alpha3: 'BOL'
          },
          {
            label: 'Bosnie-Herz\u00e9govine',
            alpha3: 'BIH'
          },
          {
            label: 'Botswana',
            alpha3: 'BWA'
          },
          {
            label: 'Brunei Darussalam',
            alpha3: 'BRN'
          },
          {
            label: 'Br\u00e9sil',
            alpha3: 'BRA'
          },
          {
            label: 'Bulgarie',
            alpha3: 'BGR'
          },
          {
            label: 'Burkina Faso',
            alpha3: 'BFA'
          },
          {
            label: 'Burundi',
            alpha3: 'BDI'
          },
          {
            label: 'B\u00e9nin',
            alpha3: 'BEN'
          },
          {
            label: 'Cambodge',
            alpha3: 'KHM'
          },
          {
            label: 'Cameroun',
            alpha3: 'CMR'
          },
          {
            label: 'Canada',
            alpha3: 'CAN'
          },
          {
            label: 'Cap-Vert',
            alpha3: 'CPV'
          },
          {
            label: 'Chili',
            alpha3: 'CHL'
          },
          {
            label: 'Chine',
            alpha3: 'CHN'
          },
          {
            label: 'Chypre',
            alpha3: 'CYP'
          },
          {
            label: 'Colombie',
            alpha3: 'COL'
          },
          {
            label: 'Comores',
            alpha3: 'COM'
          },
          {
            label: 'Cor\u00e9e du Sud',
            alpha3: 'KOR'
          },
          {
            label: 'Costa Rica',
            alpha3: 'CRI'
          },
          {
            label: 'Croatie',
            alpha3: 'HRV'
          },
          {
            label: 'Cuba',
            alpha3: 'CUB'
          },
          {
            label: 'C\u00f4te d\u2019Ivoire',
            alpha3: 'CIV'
          },
          {
            label: 'Danemark',
            alpha3: 'DNK'
          },
          {
            label: 'Djibouti',
            alpha3: 'DJI'
          },
          {
            label: 'Dominique',
            alpha3: 'DMA'
          },
          {
            label: 'Egypte',
            alpha3: 'EGY'
          },
          {
            label: 'Equateur',
            alpha3: 'ECU'
          },
          {
            label: 'Erythr\u00e9e',
            alpha3: 'ERI'
          },
          {
            label: 'Espagne',
            alpha3: 'ESP'
          },
          {
            label: 'Estonie',
            alpha3: 'EST'
          },
          {
            label: 'Eswatini (Swaziland)',
            alpha3: 'SWZ'
          },
          {
            label: 'Ethiopie',
            alpha3: 'ETH'
          },
          {
            label: 'Fidji',
            alpha3: 'FJI'
          },
          {
            label: 'Finlande',
            alpha3: 'FIN'
          },
          {
            label: 'France',
            alpha3: 'FRA'
          },
          {
            label: 'Gabon',
            alpha3: 'GAB'
          },
          {
            label: 'Gambie',
            alpha3: 'GMB'
          },
          {
            label: 'Ghana',
            alpha3: 'GHA'
          },
          {
            label: 'Grenade',
            alpha3: 'GRD'
          },
          {
            label: 'Gr\u00e8ce',
            alpha3: 'GRC'
          },
          {
            label: 'Guatemala',
            alpha3: 'GTM'
          },
          {
            label: 'Guin\u00e9e',
            alpha3: 'GIN'
          },
          {
            label: 'Guin\u00e9e Bissau',
            alpha3: 'GNB'
          },
          {
            label: 'Guin\u00e9e Equatoriale',
            alpha3: 'GNQ'
          },
          {
            label: 'G\u00e9orgie',
            alpha3: 'GEO'
          },
          {
            label: 'Ha\u00efti',
            alpha3: 'HTI'
          },
          {
            label: 'Honduras',
            alpha3: 'HND'
          },
          {
            label: 'Hong Kong',
            alpha3: 'HKG'
          },
          {
            label: 'Hongrie',
            alpha3: 'HUN'
          },
          {
            label: 'Iles Marshall',
            alpha3: 'MHL'
          },
          {
            label: 'Iles Salomon',
            alpha3: 'SLB'
          },
          {
            label: 'Inde',
            alpha3: 'IND'
          },
          {
            label: 'Indon\u00e9sie',
            alpha3: 'IDN'
          },
          {
            label: 'Irak',
            alpha3: 'IRQ'
          },
          {
            label: 'Irlande',
            alpha3: 'IRL'
          },
          {
            label: 'Islande',
            alpha3: 'ISL'
          },
          {
            label: 'Isra\u00ebl',
            alpha3: 'ISR'
          },
          {
            label: 'Italie',
            alpha3: 'ITA'
          },
          {
            label: 'Jama\u00efque',
            alpha3: 'JAM'
          },
          {
            label: 'Japon',
            alpha3: 'JPN'
          },
          {
            label: 'Jordanie',
            alpha3: 'JOR'
          },
          {
            label: 'Kazakhstan',
            alpha3: 'KAZ'
          },
          {
            label: 'Kenya',
            alpha3: 'KEN'
          },
          {
            label: 'Kirghizistan',
            alpha3: 'KGZ'
          },
          {
            label: 'Kiribati',
            alpha3: 'KIR'
          },
          {
            label: 'Kowe\u00eft',
            alpha3: 'KWT'
          },
          {
            label: 'Laos',
            alpha3: 'LAO'
          },
          {
            label: 'Lesotho',
            alpha3: 'LSO'
          },
          {
            label: 'Lettonie',
            alpha3: 'LVA'
          },
          {
            label: 'Liban',
            alpha3: 'LBN'
          },
          {
            label: 'Libye',
            alpha3: 'LBY'
          },
          {
            label: 'Lib\u00e9ria',
            alpha3: 'LBR'
          },
          {
            label: 'Liechtenstein',
            alpha3: 'LIE'
          },
          {
            label: 'Lituanie',
            alpha3: 'LTU'
          },
          {
            label: 'Luxembourg',
            alpha3: 'LUX'
          },
          {
            label: 'Mac\u00e9doine',
            alpha3: 'MKD'
          },
          {
            label: 'Madagascar',
            alpha3: 'MDG'
          },
          {
            label: 'Malaisie',
            alpha3: 'MYS'
          },
          {
            label: 'Malawi',
            alpha3: 'MWI'
          },
          {
            label: 'Maldives',
            alpha3: 'MDV'
          },
          {
            label: 'Mali',
            alpha3: 'MLI'
          },
          {
            label: 'Malte',
            alpha3: 'MLT'
          },
          {
            label: 'Maurice',
            alpha3: 'MUS'
          },
          {
            label: 'Mauritanie',
            alpha3: 'MRT'
          },
          {
            label: 'Mexique',
            alpha3: 'MEX'
          },
          {
            label: 'Micron\u00e9sie',
            alpha3: 'FSM'
          },
          {
            label: 'Moldavie',
            alpha3: 'MDA'
          },
          {
            label: 'Monaco',
            alpha3: 'MCO'
          },
          {
            label: 'Mongolie',
            alpha3: 'MNG'
          },
          {
            label: 'Mont\u00e9n\u00e9gro',
            alpha3: 'MNE'
          },
          {
            label: 'Mozambique',
            alpha3: 'MOZ'
          },
          {
            label: 'Myanmar',
            alpha3: 'MMR'
          },
          {
            label: 'Namibie',
            alpha3: 'NAM'
          },
          {
            label: 'Nauru',
            alpha3: 'NRU'
          },
          {
            label: 'Nicaragua',
            alpha3: 'NIC'
          },
          {
            label: 'Niger',
            alpha3: 'NER'
          },
          {
            label: 'Nigeria',
            alpha3: 'NGA'
          },
          {
            label: 'Norv\u00e8ge',
            alpha3: 'NOR'
          },
          {
            label: 'Nouvelle-Cal\u00e9donie',
            alpha3: 'NCL'
          },
          {
            label: 'Nouvelle-Z\u00e9lande',
            alpha3: 'NZL'
          },
          {
            label: 'N\u00e9pal',
            alpha3: 'NPL'
          },
          {
            label: 'Oman',
            alpha3: 'OMN'
          },
          {
            label: 'Ouganda',
            alpha3: 'UGA'
          },
          {
            label: 'Ouzb\u00e9kistan',
            alpha3: 'UZB'
          },
          {
            label: 'Pakistan',
            alpha3: 'PAK'
          },
          {
            label: 'Palaos',
            alpha3: 'PLW'
          },
          {
            label: 'Palestine',
            alpha3: 'PSE'
          },
          {
            label: 'Panama',
            alpha3: 'PAN'
          },
          {
            label: 'Papouasie-Nouvelle-Guin\u00e9e',
            alpha3: 'PNG'
          },
          {
            label: 'Paraguay',
            alpha3: 'PRY'
          },
          {
            label: 'Pays-Bas',
            alpha3: 'NLD'
          },
          {
            label: 'Philippines',
            alpha3: 'PHL'
          },
          {
            label: 'Pologne',
            alpha3: 'POL'
          },
          {
            label: 'Polyn\u00e9sie fran\u00e7aise',
            alpha3: 'PYF'
          },
          {
            label: 'Portugal',
            alpha3: 'PRT'
          },
          {
            label: 'P\u00e9rou',
            alpha3: 'PER'
          },
          {
            label: 'Qatar',
            alpha3: 'QAT'
          },
          {
            label: 'Roumanie',
            alpha3: 'ROU'
          },
          {
            label: 'Royaume-Uni',
            alpha3: 'GBR'
          },
          {
            label: 'Rwanda',
            alpha3: 'RWA'
          },
          {
            label: 'R\u00e9publique centrafricaine',
            alpha3: 'CAF'
          },
          {
            label: 'R\u00e9publique dominicaine',
            alpha3: 'DOM'
          },
          {
            label: 'R\u00e9publique du Congo',
            alpha3: 'COG'
          },
          {
            label: 'R\u00e9publique d\u00e9mocratique du Congo',
            alpha3: 'COD'
          },
          {
            label: 'R\u00e9publique tch\u00e8que',
            alpha3: 'CZE'
          },
          {
            label: 'Saint-Kitts-et-Nevis',
            alpha3: 'KNA'
          },
          {
            label: 'Saint-Marin',
            alpha3: 'SMR'
          },
          {
            label: 'Saint-Martin (partie fran\u00e7aise)',
            alpha3: 'MAF'
          },
          {
            label: 'Saint-Pierre-et-Miquelon',
            alpha3: 'SPM'
          },
          {
            label: 'Saint-Si\u00e8ge (Vatican)',
            alpha3: 'VAT'
          },
          {
            label: 'Saint-Vincent-et-les Grenadines',
            alpha3: 'VCT'
          },
          {
            label: 'Sainte-Lucie',
            alpha3: 'LCA'
          },
          {
            label: 'Salvador',
            alpha3: 'SLV'
          },
          {
            label: 'Samoa',
            alpha3: 'WSM'
          },
          {
            label: 'Sao Tom\u00e9-et-Principe',
            alpha3: 'STP'
          },
          {
            label: 'Serbie',
            alpha3: 'SRB'
          },
          {
            label: 'Seychelles',
            alpha3: 'SYC'
          },
          {
            label: 'Sierra Leone',
            alpha3: 'SLE'
          },
          {
            label: 'Singapour',
            alpha3: 'SGP'
          },
          {
            label: 'Slovaquie',
            alpha3: 'SVK'
          },
          {
            label: 'Slov\u00e9nie',
            alpha3: 'SVN'
          },
          {
            label: 'Somalie',
            alpha3: 'SOM'
          },
          {
            label: 'Soudan',
            alpha3: 'SDN'
          },
          {
            label: 'Sri Lanka',
            alpha3: 'LKA'
          },
          {
            label: 'Suriname',
            alpha3: 'SUR'
          },
          {
            label: 'Su\u00e8de',
            alpha3: 'SWE'
          },
          {
            label: 'S\u00e9n\u00e9gal',
            alpha3: 'SEN'
          },
          {
            label: 'Tadjikistan',
            alpha3: 'TJK'
          },
          {
            label: 'Taiwan',
            alpha3: 'TWN'
          },
          {
            label: 'Tanzanie',
            alpha3: 'TZA'
          },
          {
            label: 'Tchad',
            alpha3: 'TCD'
          },
          {
            label: 'Terres australes et antarctiques fran\u00e7aises',
            alpha3: 'ATF'
          },
          {
            label: 'Tha\u00eflande',
            alpha3: 'THA'
          },
          {
            label: 'Timor-Leste',
            alpha3: 'TLS'
          },
          {
            label: 'Togo',
            alpha3: 'TGO'
          },
          {
            label: 'Tonga',
            alpha3: 'TON'
          },
          {
            label: 'Trinit\u00e9-et-Tobago',
            alpha3: 'TTO'
          },
          {
            label: 'Tunisie',
            alpha3: 'TUN'
          },
          {
            label: 'Turkm\u00e9nistan',
            alpha3: 'TKM'
          },
          {
            label: 'Turquie',
            alpha3: 'TUR'
          },
          {
            label: 'Tuvalu',
            alpha3: 'TUV'
          },
          {
            label: 'Ukraine',
            alpha3: 'UKR'
          },
          {
            label: 'Uruguay',
            alpha3: 'URY'
          },
          {
            label: 'Vanuatu',
            alpha3: 'VUT'
          },
          {
            label: 'Venezuela',
            alpha3: 'VEN'
          },
          {
            label: 'Vi\u00eat Nam',
            alpha3: 'VNM'
          },
          {
            label: 'Wallis-et-Futuna',
            alpha3: 'WLF'
          },
          {
            label: 'Y\u00e9men',
            alpha3: 'YEM'
          },
          {
            label: 'Zambie',
            alpha3: 'ZMB'
          },
          {
            label: 'Zimbabwe',
            alpha3: 'ZWE'
          }
        ],
        en: [
          {
            label: 'Albania',
            alpha3: 'ALB'
          },
          {
            label: 'Algeria',
            alpha3: 'DZA'
          },
          {
            label: 'Andorra',
            alpha3: 'AND'
          },
          {
            label: 'Angola',
            alpha3: 'AGO'
          },
          {
            label: 'Antigua and Barbuda',
            alpha3: 'ATG'
          },
          {
            label: 'Argentina',
            alpha3: 'ARG'
          },
          {
            label: 'Armenia',
            alpha3: 'ARM'
          },
          {
            label: 'Australia',
            alpha3: 'AUS'
          },
          {
            label: 'Austria',
            alpha3: 'AUT'
          },
          {
            label: 'Azerbaijan',
            alpha3: 'AZE'
          },
          {
            label: 'Bahamas',
            alpha3: 'BHS'
          },
          {
            label: 'Bahrain',
            alpha3: 'BHR'
          },
          {
            label: 'Bangladesh',
            alpha3: 'BGD'
          },
          {
            label: 'Barbados',
            alpha3: 'BRB'
          },
          {
            label: 'Belarus',
            alpha3: 'BLR'
          },
          {
            label: 'Belgium',
            alpha3: 'BEL'
          },
          {
            label: 'Belize',
            alpha3: 'BLZ'
          },
          {
            label: 'Benin',
            alpha3: 'BEN'
          },
          {
            label: 'Bhutan',
            alpha3: 'BTN'
          },
          {
            label: 'Bolivia',
            alpha3: 'BOL'
          },
          {
            label: 'Bosnia and Herzegovina',
            alpha3: 'BIH'
          },
          {
            label: 'Botswana',
            alpha3: 'BWA'
          },
          {
            label: 'Brazil',
            alpha3: 'BRA'
          },
          {
            label: 'Brunei',
            alpha3: 'BRN'
          },
          {
            label: 'Bulgaria',
            alpha3: 'BGR'
          },
          {
            label: 'Burkina Faso',
            alpha3: 'BFA'
          },
          {
            label: 'Burundi',
            alpha3: 'BDI'
          },
          {
            label: 'Cambodia',
            alpha3: 'KHM'
          },
          {
            label: 'Cameroon',
            alpha3: 'CMR'
          },
          {
            label: 'Canada',
            alpha3: 'CAN'
          },
          {
            label: 'Cape Verde',
            alpha3: 'CPV'
          },
          {
            label: 'Central African Republic',
            alpha3: 'CAF'
          },
          {
            label: 'Chad',
            alpha3: 'TCD'
          },
          {
            label: 'Chile',
            alpha3: 'CHL'
          },
          {
            label: 'China',
            alpha3: 'CHN'
          },
          {
            label: 'Colombia',
            alpha3: 'COL'
          },
          {
            label: 'Comoros',
            alpha3: 'COM'
          },
          {
            label: 'Congo',
            alpha3: 'COG'
          },
          {
            label: 'Congo, Democratic Republic of the',
            alpha3: 'COD'
          },
          {
            label: 'Costa Rica',
            alpha3: 'CRI'
          },
          {
            label: 'Croatia',
            alpha3: 'HRV'
          },
          {
            label: 'Cuba',
            alpha3: 'CUB'
          },
          {
            label: 'Cyprus',
            alpha3: 'CYP'
          },
          {
            label: 'Czechia',
            alpha3: 'CZE'
          },
          {
            label: 'Denmark',
            alpha3: 'DNK'
          },
          {
            label: 'Djibouti',
            alpha3: 'DJI'
          },
          {
            label: 'Dominica',
            alpha3: 'DMA'
          },
          {
            label: 'Dominican Republic',
            alpha3: 'DOM'
          },
          {
            label: 'Ecuador',
            alpha3: 'ECU'
          },
          {
            label: 'Egypt',
            alpha3: 'EGY'
          },
          {
            label: 'El Salvador',
            alpha3: 'SLV'
          },
          {
            label: 'Equatorial Guinea',
            alpha3: 'GNQ'
          },
          {
            label: 'Eritrea',
            alpha3: 'ERI'
          },
          {
            label: 'Estonia',
            alpha3: 'EST'
          },
          {
            label: 'Eswatini',
            alpha3: 'SWZ'
          },
          {
            label: 'Ethiopia',
            alpha3: 'ETH'
          },
          {
            label: 'Fiji',
            alpha3: 'FJI'
          },
          {
            label: 'Finland',
            alpha3: 'FIN'
          },
          {
            label: 'France',
            alpha3: 'FRA'
          },
          {
            label: 'French Polynesia',
            alpha3: 'PYF'
          },
          {
            label: 'French Southern Territories',
            alpha3: 'ATF'
          },
          {
            label: 'Gabon',
            alpha3: 'GAB'
          },
          {
            label: 'Gambia',
            alpha3: 'GMB'
          },
          {
            label: 'Georgia',
            alpha3: 'GEO'
          },
          {
            label: 'Germany',
            alpha3: 'DEU'
          },
          {
            label: 'Ghana',
            alpha3: 'GHA'
          },
          {
            label: 'Greece',
            alpha3: 'GRC'
          },
          {
            label: 'Grenada',
            alpha3: 'GRD'
          },
          {
            label: 'Guatemala',
            alpha3: 'GTM'
          },
          {
            label: 'Guinea',
            alpha3: 'GIN'
          },
          {
            label: 'Guinea-Bissau',
            alpha3: 'GNB'
          },
          {
            label: 'Haiti',
            alpha3: 'HTI'
          },
          {
            label: 'Honduras',
            alpha3: 'HND'
          },
          {
            label: 'Hong Kong',
            alpha3: 'HKG'
          },
          {
            label: 'Hungary',
            alpha3: 'HUN'
          },
          {
            label: 'Iceland',
            alpha3: 'ISL'
          },
          {
            label: 'India',
            alpha3: 'IND'
          },
          {
            label: 'Indonesia',
            alpha3: 'IDN'
          },
          {
            label: 'Iraq',
            alpha3: 'IRQ'
          },
          {
            label: 'Ireland',
            alpha3: 'IRL'
          },
          {
            label: 'Israel',
            alpha3: 'ISR'
          },
          {
            label: 'Italy',
            alpha3: 'ITA'
          },
          {
            label: 'Ivory Coast',
            alpha3: 'CIV'
          },
          {
            label: 'Jamaica',
            alpha3: 'JAM'
          },
          {
            label: 'Japan',
            alpha3: 'JPN'
          },
          {
            label: 'Jordan',
            alpha3: 'JOR'
          },
          {
            label: 'Kazakhstan',
            alpha3: 'KAZ'
          },
          {
            label: 'Kenya',
            alpha3: 'KEN'
          },
          {
            label: 'Kiribati',
            alpha3: 'KIR'
          },
          {
            label: 'Kuwait',
            alpha3: 'KWT'
          },
          {
            label: 'Kyrgyzstan',
            alpha3: 'KGZ'
          },
          {
            label: 'Laos',
            alpha3: 'LAO'
          },
          {
            label: 'Latvia',
            alpha3: 'LVA'
          },
          {
            label: 'Lebanon',
            alpha3: 'LBN'
          },
          {
            label: 'Lesotho',
            alpha3: 'LSO'
          },
          {
            label: 'Liberia',
            alpha3: 'LBR'
          },
          {
            label: 'Libya',
            alpha3: 'LBY'
          },
          {
            label: 'Liechtenstein',
            alpha3: 'LIE'
          },
          {
            label: 'Lithuania',
            alpha3: 'LTU'
          },
          {
            label: 'Luxembourg',
            alpha3: 'LUX'
          },
          {
            label: 'Madagascar',
            alpha3: 'MDG'
          },
          {
            label: 'Malawi',
            alpha3: 'MWI'
          },
          {
            label: 'Malaysia',
            alpha3: 'MYS'
          },
          {
            label: 'Maldives',
            alpha3: 'MDV'
          },
          {
            label: 'Mali',
            alpha3: 'MLI'
          },
          {
            label: 'Malta',
            alpha3: 'MLT'
          },
          {
            label: 'Marshall Islands',
            alpha3: 'MHL'
          },
          {
            label: 'Mauritania',
            alpha3: 'MRT'
          },
          {
            label: 'Mauritius',
            alpha3: 'MUS'
          },
          {
            label: 'Mexico',
            alpha3: 'MEX'
          },
          {
            label: 'Micronesia',
            alpha3: 'FSM'
          },
          {
            label: 'Moldova',
            alpha3: 'MDA'
          },
          {
            label: 'Monaco',
            alpha3: 'MCO'
          },
          {
            label: 'Mongolia',
            alpha3: 'MNG'
          },
          {
            label: 'Montenegro',
            alpha3: 'MNE'
          },
          {
            label: 'Mozambique',
            alpha3: 'MOZ'
          },
          {
            label: 'Myanmar',
            alpha3: 'MMR'
          },
          {
            label: 'Namibia',
            alpha3: 'NAM'
          },
          {
            label: 'Nauru',
            alpha3: 'NRU'
          },
          {
            label: 'Nepal',
            alpha3: 'NPL'
          },
          {
            label: 'Netherlands',
            alpha3: 'NLD'
          },
          {
            label: 'New Caledonia',
            alpha3: 'NCL'
          },
          {
            label: 'New Zealand',
            alpha3: 'NZL'
          },
          {
            label: 'Nicaragua',
            alpha3: 'NIC'
          },
          {
            label: 'Niger',
            alpha3: 'NER'
          },
          {
            label: 'Nigeria',
            alpha3: 'NGA'
          },
          {
            label: 'North Macedonia',
            alpha3: 'MKD'
          },
          {
            label: 'Norway',
            alpha3: 'NOR'
          },
          {
            label: 'Oman',
            alpha3: 'OMN'
          },
          {
            label: 'Pakistan',
            alpha3: 'PAK'
          },
          {
            label: 'Palau',
            alpha3: 'PLW'
          },
          {
            label: 'Palestine, State of',
            alpha3: 'PSE'
          },
          {
            label: 'Panama',
            alpha3: 'PAN'
          },
          {
            label: 'Papua New Guinea',
            alpha3: 'PNG'
          },
          {
            label: 'Paraguay',
            alpha3: 'PRY'
          },
          {
            label: 'Peru',
            alpha3: 'PER'
          },
          {
            label: 'Philippines',
            alpha3: 'PHL'
          },
          {
            label: 'Poland',
            alpha3: 'POL'
          },
          {
            label: 'Portugal',
            alpha3: 'PRT'
          },
          {
            label: 'Qatar',
            alpha3: 'QAT'
          },
          {
            label: 'Romania',
            alpha3: 'ROU'
          },
          {
            label: 'Rwanda',
            alpha3: 'RWA'
          },
          {
            label: 'Saint Kitts and Nevis',
            alpha3: 'KNA'
          },
          {
            label: 'Saint Lucia',
            alpha3: 'LCA'
          },
          {
            label: 'Saint Martin (French part)',
            alpha3: 'MAF'
          },
          {
            label: 'Saint Pierre and Miquelon',
            alpha3: 'SPM'
          },
          {
            label: 'Saint Vincent and the Grenadines',
            alpha3: 'VCT'
          },
          {
            label: 'Samoa',
            alpha3: 'WSM'
          },
          {
            label: 'San Marino',
            alpha3: 'SMR'
          },
          {
            label: 'Sao Tome and Principe',
            alpha3: 'STP'
          },
          {
            label: 'Saudi Arabia',
            alpha3: 'SAU'
          },
          {
            label: 'Senegal',
            alpha3: 'SEN'
          },
          {
            label: 'Serbia',
            alpha3: 'SRB'
          },
          {
            label: 'Seychelles',
            alpha3: 'SYC'
          },
          {
            label: 'Sierra Leone',
            alpha3: 'SLE'
          },
          {
            label: 'Singapore',
            alpha3: 'SGP'
          },
          {
            label: 'Slovakia',
            alpha3: 'SVK'
          },
          {
            label: 'Slovenia',
            alpha3: 'SVN'
          },
          {
            label: 'Solomon Islands',
            alpha3: 'SLB'
          },
          {
            label: 'Somalia',
            alpha3: 'SOM'
          },
          {
            label: 'South Africa',
            alpha3: 'ZAF'
          },
          {
            label: 'South Korea',
            alpha3: 'KOR'
          },
          {
            label: 'Spain',
            alpha3: 'ESP'
          },
          {
            label: 'Sri Lanka',
            alpha3: 'LKA'
          },
          {
            label: 'Sudan',
            alpha3: 'SDN'
          },
          {
            label: 'Suriname',
            alpha3: 'SUR'
          },
          {
            label: 'Sweden',
            alpha3: 'SWE'
          },
          {
            label: 'Taiwan',
            alpha3: 'TWN'
          },
          {
            label: 'Tajikistan',
            alpha3: 'TJK'
          },
          {
            label: 'Tanzania',
            alpha3: 'TZA'
          },
          {
            label: 'Thailand',
            alpha3: 'THA'
          },
          {
            label: 'Timor-Leste',
            alpha3: 'TLS'
          },
          {
            label: 'Togo',
            alpha3: 'TGO'
          },
          {
            label: 'Tonga',
            alpha3: 'TON'
          },
          {
            label: 'Trinidad and Tobago',
            alpha3: 'TTO'
          },
          {
            label: 'Tunisia',
            alpha3: 'TUN'
          },
          {
            label: 'Turkey',
            alpha3: 'TUR'
          },
          {
            label: 'Turkmenistan',
            alpha3: 'TKM'
          },
          {
            label: 'Tuvalu',
            alpha3: 'TUV'
          },
          {
            label: 'Uganda',
            alpha3: 'UGA'
          },
          {
            label: 'Ukraine',
            alpha3: 'UKR'
          },
          {
            label: 'United Kingdom',
            alpha3: 'GBR'
          },
          {
            label: 'Uruguay',
            alpha3: 'URY'
          },
          {
            label: 'Uzbekistan',
            alpha3: 'UZB'
          },
          {
            label: 'Vanuatu',
            alpha3: 'VUT'
          },
          {
            label: 'Vatican City',
            alpha3: 'VAT'
          },
          {
            label: 'Venezuela',
            alpha3: 'VEN'
          },
          {
            label: 'Vietnam',
            alpha3: 'VNM'
          },
          {
            label: 'Wallis and Futuna',
            alpha3: 'WLF'
          },
          {
            label: 'Yemen',
            alpha3: 'YEM'
          },
          {
            label: 'Zambia',
            alpha3: 'ZMB'
          },
          {
            label: 'Zimbabwe',
            alpha3: 'ZWE'
          }
        ]
      },
      nationality_countries: {
        fr: [
          {
            label: 'Afghanistan',
            alpha3: 'AFG'
          },
          {
            label: 'Afrique du Sud',
            alpha3: 'ZAF'
          },
          {
            label: 'Albanie',
            alpha3: 'ALB'
          },
          {
            label: 'Alg\u00e9rie',
            alpha3: 'DZA'
          },
          {
            label: 'Allemagne',
            alpha3: 'DEU'
          },
          {
            label: 'Andorre',
            alpha3: 'AND'
          },
          {
            label: 'Angola',
            alpha3: 'AGO'
          },
          {
            label: 'Antigua-et-Barbuda',
            alpha3: 'ATG'
          },
          {
            label: 'Arabie Saoudite',
            alpha3: 'SAU'
          },
          {
            label: 'Argentine',
            alpha3: 'ARG'
          },
          {
            label: 'Arm\u00e9nie',
            alpha3: 'ARM'
          },
          {
            label: 'Australie',
            alpha3: 'AUS'
          },
          {
            label: 'Autriche',
            alpha3: 'AUT'
          },
          {
            label: 'Azerba\u00efdjan',
            alpha3: 'AZE'
          },
          {
            label: 'Bahamas',
            alpha3: 'BHS'
          },
          {
            label: 'Bahre\u00efn',
            alpha3: 'BHR'
          },
          {
            label: 'Bangladesh',
            alpha3: 'BGD'
          },
          {
            label: 'Barbade',
            alpha3: 'BRB'
          },
          {
            label: 'Belgique',
            alpha3: 'BEL'
          },
          {
            label: 'Belize',
            alpha3: 'BLZ'
          },
          {
            label: 'Bhoutan',
            alpha3: 'BTN'
          },
          {
            label: 'Bi\u00e9lorussie',
            alpha3: 'BLR'
          },
          {
            label: 'Bolivie',
            alpha3: 'BOL'
          },
          {
            label: 'Bosnie-Herz\u00e9govine',
            alpha3: 'BIH'
          },
          {
            label: 'Botswana',
            alpha3: 'BWA'
          },
          {
            label: 'Brunei Darussalam',
            alpha3: 'BRN'
          },
          {
            label: 'Br\u00e9sil',
            alpha3: 'BRA'
          },
          {
            label: 'Bulgarie',
            alpha3: 'BGR'
          },
          {
            label: 'Burkina Faso',
            alpha3: 'BFA'
          },
          {
            label: 'Burundi',
            alpha3: 'BDI'
          },
          {
            label: 'B\u00e9nin',
            alpha3: 'BEN'
          },
          {
            label: 'Cambodge',
            alpha3: 'KHM'
          },
          {
            label: 'Cameroun',
            alpha3: 'CMR'
          },
          {
            label: 'Canada',
            alpha3: 'CAN'
          },
          {
            label: 'Cap-Vert',
            alpha3: 'CPV'
          },
          {
            label: 'Chili',
            alpha3: 'CHL'
          },
          {
            label: 'Chine',
            alpha3: 'CHN'
          },
          {
            label: 'Chypre',
            alpha3: 'CYP'
          },
          {
            label: 'Colombie',
            alpha3: 'COL'
          },
          {
            label: 'Comores',
            alpha3: 'COM'
          },
          {
            label: 'Cor\u00e9e du Nord',
            alpha3: 'PRK'
          },
          {
            label: 'Cor\u00e9e du Sud',
            alpha3: 'KOR'
          },
          {
            label: 'Costa Rica',
            alpha3: 'CRI'
          },
          {
            label: 'Croatie',
            alpha3: 'HRV'
          },
          {
            label: 'Cuba',
            alpha3: 'CUB'
          },
          {
            label: 'C\u00f4te d\u2019Ivoire',
            alpha3: 'CIV'
          },
          {
            label: 'Danemark',
            alpha3: 'DNK'
          },
          {
            label: 'Djibouti',
            alpha3: 'DJI'
          },
          {
            label: 'Dominique',
            alpha3: 'DMA'
          },
          {
            label: 'Egypte',
            alpha3: 'EGY'
          },
          {
            label: 'Emirats Arabes Unis',
            alpha3: 'ARE'
          },
          {
            label: 'Equateur',
            alpha3: 'ECU'
          },
          {
            label: 'Erythr\u00e9e',
            alpha3: 'ERI'
          },
          {
            label: 'Espagne',
            alpha3: 'ESP'
          },
          {
            label: 'Estonie',
            alpha3: 'EST'
          },
          {
            label: 'Eswatini (Swaziland)',
            alpha3: 'SWZ'
          },
          {
            label: 'Etats-Unis',
            alpha3: 'USA'
          },
          {
            label: 'Ethiopie',
            alpha3: 'ETH'
          },
          {
            label: 'Fidji',
            alpha3: 'FJI'
          },
          {
            label: 'Finlande',
            alpha3: 'FIN'
          },
          {
            label: 'France',
            alpha3: 'FRA'
          },
          {
            label: 'Gabon',
            alpha3: 'GAB'
          },
          {
            label: 'Gambie',
            alpha3: 'GMB'
          },
          {
            label: 'Ghana',
            alpha3: 'GHA'
          },
          {
            label: 'Grenade',
            alpha3: 'GRD'
          },
          {
            label: 'Gr\u00e8ce',
            alpha3: 'GRC'
          },
          {
            label: 'Guatemala',
            alpha3: 'GTM'
          },
          {
            label: 'Guin\u00e9e',
            alpha3: 'GIN'
          },
          {
            label: 'Guin\u00e9e Bissau',
            alpha3: 'GNB'
          },
          {
            label: 'Guin\u00e9e Equatoriale',
            alpha3: 'GNQ'
          },
          {
            label: 'G\u00e9orgie',
            alpha3: 'GEO'
          },
          {
            label: 'Ha\u00efti',
            alpha3: 'HTI'
          },
          {
            label: 'Honduras',
            alpha3: 'HND'
          },
          {
            label: 'Hongrie',
            alpha3: 'HUN'
          },
          {
            label: 'Iles Marshall',
            alpha3: 'MHL'
          },
          {
            label: 'Iles Salomon',
            alpha3: 'SLB'
          },
          {
            label: 'Inde',
            alpha3: 'IND'
          },
          {
            label: 'Indon\u00e9sie',
            alpha3: 'IDN'
          },
          {
            label: 'Irak',
            alpha3: 'IRQ'
          },
          {
            label: 'Iran',
            alpha3: 'IRN'
          },
          {
            label: 'Irlande',
            alpha3: 'IRL'
          },
          {
            label: 'Islande',
            alpha3: 'ISL'
          },
          {
            label: 'Isra\u00ebl',
            alpha3: 'ISR'
          },
          {
            label: 'Italie',
            alpha3: 'ITA'
          },
          {
            label: 'Jama\u00efque',
            alpha3: 'JAM'
          },
          {
            label: 'Japon',
            alpha3: 'JPN'
          },
          {
            label: 'Jordanie',
            alpha3: 'JOR'
          },
          {
            label: 'Kazakhstan',
            alpha3: 'KAZ'
          },
          {
            label: 'Kenya',
            alpha3: 'KEN'
          },
          {
            label: 'Kirghizistan',
            alpha3: 'KGZ'
          },
          {
            label: 'Kiribati',
            alpha3: 'KIR'
          },
          {
            label: 'Kowe\u00eft',
            alpha3: 'KWT'
          },
          {
            label: 'Laos',
            alpha3: 'LAO'
          },
          {
            label: 'Lesotho',
            alpha3: 'LSO'
          },
          {
            label: 'Lettonie',
            alpha3: 'LVA'
          },
          {
            label: 'Liban',
            alpha3: 'LBN'
          },
          {
            label: 'Libye',
            alpha3: 'LBY'
          },
          {
            label: 'Lib\u00e9ria',
            alpha3: 'LBR'
          },
          {
            label: 'Liechtenstein',
            alpha3: 'LIE'
          },
          {
            label: 'Lituanie',
            alpha3: 'LTU'
          },
          {
            label: 'Luxembourg',
            alpha3: 'LUX'
          },
          {
            label: 'Mac\u00e9doine',
            alpha3: 'MKD'
          },
          {
            label: 'Madagascar',
            alpha3: 'MDG'
          },
          {
            label: 'Malaisie',
            alpha3: 'MYS'
          },
          {
            label: 'Malawi',
            alpha3: 'MWI'
          },
          {
            label: 'Maldives',
            alpha3: 'MDV'
          },
          {
            label: 'Mali',
            alpha3: 'MLI'
          },
          {
            label: 'Malte',
            alpha3: 'MLT'
          },
          {
            label: 'Maroc',
            alpha3: 'MAR'
          },
          {
            label: 'Maurice',
            alpha3: 'MUS'
          },
          {
            label: 'Mauritanie',
            alpha3: 'MRT'
          },
          {
            label: 'Mexique',
            alpha3: 'MEX'
          },
          {
            label: 'Micron\u00e9sie',
            alpha3: 'FSM'
          },
          {
            label: 'Moldavie',
            alpha3: 'MDA'
          },
          {
            label: 'Monaco',
            alpha3: 'MCO'
          },
          {
            label: 'Mongolie',
            alpha3: 'MNG'
          },
          {
            label: 'Mont\u00e9n\u00e9gro',
            alpha3: 'MNE'
          },
          {
            label: 'Mozambique',
            alpha3: 'MOZ'
          },
          {
            label: 'Myanmar',
            alpha3: 'MMR'
          },
          {
            label: 'Namibie',
            alpha3: 'NAM'
          },
          {
            label: 'Nauru',
            alpha3: 'NRU'
          },
          {
            label: 'Nicaragua',
            alpha3: 'NIC'
          },
          {
            label: 'Niger',
            alpha3: 'NER'
          },
          {
            label: 'Nigeria',
            alpha3: 'NGA'
          },
          {
            label: 'Norv\u00e8ge',
            alpha3: 'NOR'
          },
          {
            label: 'Nouvelle-Z\u00e9lande',
            alpha3: 'NZL'
          },
          {
            label: 'N\u00e9pal',
            alpha3: 'NPL'
          },
          {
            label: 'Oman',
            alpha3: 'OMN'
          },
          {
            label: 'Ouganda',
            alpha3: 'UGA'
          },
          {
            label: 'Ouzb\u00e9kistan',
            alpha3: 'UZB'
          },
          {
            label: 'Pakistan',
            alpha3: 'PAK'
          },
          {
            label: 'Palaos',
            alpha3: 'PLW'
          },
          {
            label: 'Palestine',
            alpha3: 'PSE'
          },
          {
            label: 'Panama',
            alpha3: 'PAN'
          },
          {
            label: 'Papouasie-Nouvelle-Guin\u00e9e',
            alpha3: 'PNG'
          },
          {
            label: 'Paraguay',
            alpha3: 'PRY'
          },
          {
            label: 'Pays-Bas',
            alpha3: 'NLD'
          },
          {
            label: 'Philippines',
            alpha3: 'PHL'
          },
          {
            label: 'Pologne',
            alpha3: 'POL'
          },
          {
            label: 'Portugal',
            alpha3: 'PRT'
          },
          {
            label: 'P\u00e9rou',
            alpha3: 'PER'
          },
          {
            label: 'Qatar',
            alpha3: 'QAT'
          },
          {
            label: 'Roumanie',
            alpha3: 'ROU'
          },
          {
            label: 'Royaume-Uni',
            alpha3: 'GBR'
          },
          {
            label: 'Russie',
            alpha3: 'RUS'
          },
          {
            label: 'Rwanda',
            alpha3: 'RWA'
          },
          {
            label: 'R\u00e9publique centrafricaine',
            alpha3: 'CAF'
          },
          {
            label: 'R\u00e9publique dominicaine',
            alpha3: 'DOM'
          },
          {
            label: 'R\u00e9publique du Congo',
            alpha3: 'COG'
          },
          {
            label: 'R\u00e9publique d\u00e9mocratique du Congo',
            alpha3: 'COD'
          },
          {
            label: 'R\u00e9publique tch\u00e8que',
            alpha3: 'CZE'
          },
          {
            label: 'Saint-Kitts-et-Nevis',
            alpha3: 'KNA'
          },
          {
            label: 'Saint-Marin',
            alpha3: 'SMR'
          },
          {
            label: 'Saint-Si\u00e8ge (Vatican)',
            alpha3: 'VAT'
          },
          {
            label: 'Saint-Vincent-et-les Grenadines',
            alpha3: 'VCT'
          },
          {
            label: 'Sainte-Lucie',
            alpha3: 'LCA'
          },
          {
            label: 'Salvador',
            alpha3: 'SLV'
          },
          {
            label: 'Samoa',
            alpha3: 'WSM'
          },
          {
            label: 'Sao Tom\u00e9-et-Principe',
            alpha3: 'STP'
          },
          {
            label: 'Serbie',
            alpha3: 'SRB'
          },
          {
            label: 'Seychelles',
            alpha3: 'SYC'
          },
          {
            label: 'Sierra Leone',
            alpha3: 'SLE'
          },
          {
            label: 'Singapour',
            alpha3: 'SGP'
          },
          {
            label: 'Slovaquie',
            alpha3: 'SVK'
          },
          {
            label: 'Slov\u00e9nie',
            alpha3: 'SVN'
          },
          {
            label: 'Somalie',
            alpha3: 'SOM'
          },
          {
            label: 'Soudan',
            alpha3: 'SDN'
          },
          {
            label: 'Soudan du sud',
            alpha3: 'SSD'
          },
          {
            label: 'Sri Lanka',
            alpha3: 'LKA'
          },
          {
            label: 'Suisse',
            alpha3: 'CHE'
          },
          {
            label: 'Suriname',
            alpha3: 'SUR'
          },
          {
            label: 'Su\u00e8de',
            alpha3: 'SWE'
          },
          {
            label: 'Syrie',
            alpha3: 'SYR'
          },
          {
            label: 'S\u00e9n\u00e9gal',
            alpha3: 'SEN'
          },
          {
            label: 'Tadjikistan',
            alpha3: 'TJK'
          },
          {
            label: 'Tanzanie',
            alpha3: 'TZA'
          },
          {
            label: 'Tchad',
            alpha3: 'TCD'
          },
          {
            label: 'Tha\u00eflande',
            alpha3: 'THA'
          },
          {
            label: 'Timor-Leste',
            alpha3: 'TLS'
          },
          {
            label: 'Togo',
            alpha3: 'TGO'
          },
          {
            label: 'Tonga',
            alpha3: 'TON'
          },
          {
            label: 'Trinit\u00e9-et-Tobago',
            alpha3: 'TTO'
          },
          {
            label: 'Tunisie',
            alpha3: 'TUN'
          },
          {
            label: 'Turkm\u00e9nistan',
            alpha3: 'TKM'
          },
          {
            label: 'Turquie',
            alpha3: 'TUR'
          },
          {
            label: 'Tuvalu',
            alpha3: 'TUV'
          },
          {
            label: 'Ukraine',
            alpha3: 'UKR'
          },
          {
            label: 'Uruguay',
            alpha3: 'URY'
          },
          {
            label: 'Vanuatu',
            alpha3: 'VUT'
          },
          {
            label: 'Venezuela',
            alpha3: 'VEN'
          },
          {
            label: 'Vi\u00eat Nam',
            alpha3: 'VNM'
          },
          {
            label: 'Y\u00e9men',
            alpha3: 'YEM'
          },
          {
            label: 'Zambie',
            alpha3: 'ZMB'
          },
          {
            label: 'Zimbabwe',
            alpha3: 'ZWE'
          }
        ],
        en: [
          {
            label: 'Afghanistan',
            alpha3: 'AFG'
          },
          {
            label: 'Albania',
            alpha3: 'ALB'
          },
          {
            label: 'Algeria',
            alpha3: 'DZA'
          },
          {
            label: 'Andorra',
            alpha3: 'AND'
          },
          {
            label: 'Angola',
            alpha3: 'AGO'
          },
          {
            label: 'Antigua and Barbuda',
            alpha3: 'ATG'
          },
          {
            label: 'Argentina',
            alpha3: 'ARG'
          },
          {
            label: 'Armenia',
            alpha3: 'ARM'
          },
          {
            label: 'Australia',
            alpha3: 'AUS'
          },
          {
            label: 'Austria',
            alpha3: 'AUT'
          },
          {
            label: 'Azerbaijan',
            alpha3: 'AZE'
          },
          {
            label: 'Bahamas',
            alpha3: 'BHS'
          },
          {
            label: 'Bahrain',
            alpha3: 'BHR'
          },
          {
            label: 'Bangladesh',
            alpha3: 'BGD'
          },
          {
            label: 'Barbados',
            alpha3: 'BRB'
          },
          {
            label: 'Belarus',
            alpha3: 'BLR'
          },
          {
            label: 'Belgium',
            alpha3: 'BEL'
          },
          {
            label: 'Belize',
            alpha3: 'BLZ'
          },
          {
            label: 'Benin',
            alpha3: 'BEN'
          },
          {
            label: 'Bhutan',
            alpha3: 'BTN'
          },
          {
            label: 'Bolivia',
            alpha3: 'BOL'
          },
          {
            label: 'Bosnia and Herzegovina',
            alpha3: 'BIH'
          },
          {
            label: 'Botswana',
            alpha3: 'BWA'
          },
          {
            label: 'Brazil',
            alpha3: 'BRA'
          },
          {
            label: 'Brunei',
            alpha3: 'BRN'
          },
          {
            label: 'Bulgaria',
            alpha3: 'BGR'
          },
          {
            label: 'Burkina Faso',
            alpha3: 'BFA'
          },
          {
            label: 'Burundi',
            alpha3: 'BDI'
          },
          {
            label: 'Cambodia',
            alpha3: 'KHM'
          },
          {
            label: 'Cameroon',
            alpha3: 'CMR'
          },
          {
            label: 'Canada',
            alpha3: 'CAN'
          },
          {
            label: 'Cape Verde',
            alpha3: 'CPV'
          },
          {
            label: 'Central African Republic',
            alpha3: 'CAF'
          },
          {
            label: 'Chad',
            alpha3: 'TCD'
          },
          {
            label: 'Chile',
            alpha3: 'CHL'
          },
          {
            label: 'China',
            alpha3: 'CHN'
          },
          {
            label: 'Colombia',
            alpha3: 'COL'
          },
          {
            label: 'Comoros',
            alpha3: 'COM'
          },
          {
            label: 'Congo',
            alpha3: 'COG'
          },
          {
            label: 'Congo, Democratic Republic of the',
            alpha3: 'COD'
          },
          {
            label: 'Costa Rica',
            alpha3: 'CRI'
          },
          {
            label: 'Croatia',
            alpha3: 'HRV'
          },
          {
            label: 'Cuba',
            alpha3: 'CUB'
          },
          {
            label: 'Cyprus',
            alpha3: 'CYP'
          },
          {
            label: 'Czechia',
            alpha3: 'CZE'
          },
          {
            label: 'Denmark',
            alpha3: 'DNK'
          },
          {
            label: 'Djibouti',
            alpha3: 'DJI'
          },
          {
            label: 'Dominica',
            alpha3: 'DMA'
          },
          {
            label: 'Dominican Republic',
            alpha3: 'DOM'
          },
          {
            label: 'Ecuador',
            alpha3: 'ECU'
          },
          {
            label: 'Egypt',
            alpha3: 'EGY'
          },
          {
            label: 'El Salvador',
            alpha3: 'SLV'
          },
          {
            label: 'Equatorial Guinea',
            alpha3: 'GNQ'
          },
          {
            label: 'Eritrea',
            alpha3: 'ERI'
          },
          {
            label: 'Estonia',
            alpha3: 'EST'
          },
          {
            label: 'Eswatini',
            alpha3: 'SWZ'
          },
          {
            label: 'Ethiopia',
            alpha3: 'ETH'
          },
          {
            label: 'Fiji',
            alpha3: 'FJI'
          },
          {
            label: 'Finland',
            alpha3: 'FIN'
          },
          {
            label: 'France',
            alpha3: 'FRA'
          },
          {
            label: 'Gabon',
            alpha3: 'GAB'
          },
          {
            label: 'Gambia',
            alpha3: 'GMB'
          },
          {
            label: 'Georgia',
            alpha3: 'GEO'
          },
          {
            label: 'Germany',
            alpha3: 'DEU'
          },
          {
            label: 'Ghana',
            alpha3: 'GHA'
          },
          {
            label: 'Greece',
            alpha3: 'GRC'
          },
          {
            label: 'Grenada',
            alpha3: 'GRD'
          },
          {
            label: 'Guatemala',
            alpha3: 'GTM'
          },
          {
            label: 'Guinea',
            alpha3: 'GIN'
          },
          {
            label: 'Guinea-Bissau',
            alpha3: 'GNB'
          },
          {
            label: 'Haiti',
            alpha3: 'HTI'
          },
          {
            label: 'Honduras',
            alpha3: 'HND'
          },
          {
            label: 'Hungary',
            alpha3: 'HUN'
          },
          {
            label: 'Iceland',
            alpha3: 'ISL'
          },
          {
            label: 'India',
            alpha3: 'IND'
          },
          {
            label: 'Indonesia',
            alpha3: 'IDN'
          },
          {
            label: 'Iran',
            alpha3: 'IRN'
          },
          {
            label: 'Iraq',
            alpha3: 'IRQ'
          },
          {
            label: 'Ireland',
            alpha3: 'IRL'
          },
          {
            label: 'Israel',
            alpha3: 'ISR'
          },
          {
            label: 'Italy',
            alpha3: 'ITA'
          },
          {
            label: 'Ivory Coast',
            alpha3: 'CIV'
          },
          {
            label: 'Jamaica',
            alpha3: 'JAM'
          },
          {
            label: 'Japan',
            alpha3: 'JPN'
          },
          {
            label: 'Jordan',
            alpha3: 'JOR'
          },
          {
            label: 'Kazakhstan',
            alpha3: 'KAZ'
          },
          {
            label: 'Kenya',
            alpha3: 'KEN'
          },
          {
            label: 'Kiribati',
            alpha3: 'KIR'
          },
          {
            label: 'Kuwait',
            alpha3: 'KWT'
          },
          {
            label: 'Kyrgyzstan',
            alpha3: 'KGZ'
          },
          {
            label: 'Laos',
            alpha3: 'LAO'
          },
          {
            label: 'Latvia',
            alpha3: 'LVA'
          },
          {
            label: 'Lebanon',
            alpha3: 'LBN'
          },
          {
            label: 'Lesotho',
            alpha3: 'LSO'
          },
          {
            label: 'Liberia',
            alpha3: 'LBR'
          },
          {
            label: 'Libya',
            alpha3: 'LBY'
          },
          {
            label: 'Liechtenstein',
            alpha3: 'LIE'
          },
          {
            label: 'Lithuania',
            alpha3: 'LTU'
          },
          {
            label: 'Luxembourg',
            alpha3: 'LUX'
          },
          {
            label: 'Madagascar',
            alpha3: 'MDG'
          },
          {
            label: 'Malawi',
            alpha3: 'MWI'
          },
          {
            label: 'Malaysia',
            alpha3: 'MYS'
          },
          {
            label: 'Maldives',
            alpha3: 'MDV'
          },
          {
            label: 'Mali',
            alpha3: 'MLI'
          },
          {
            label: 'Malta',
            alpha3: 'MLT'
          },
          {
            label: 'Marshall Islands',
            alpha3: 'MHL'
          },
          {
            label: 'Mauritania',
            alpha3: 'MRT'
          },
          {
            label: 'Mauritius',
            alpha3: 'MUS'
          },
          {
            label: 'Mexico',
            alpha3: 'MEX'
          },
          {
            label: 'Micronesia',
            alpha3: 'FSM'
          },
          {
            label: 'Moldova',
            alpha3: 'MDA'
          },
          {
            label: 'Monaco',
            alpha3: 'MCO'
          },
          {
            label: 'Mongolia',
            alpha3: 'MNG'
          },
          {
            label: 'Montenegro',
            alpha3: 'MNE'
          },
          {
            label: 'Morocco',
            alpha3: 'MAR'
          },
          {
            label: 'Mozambique',
            alpha3: 'MOZ'
          },
          {
            label: 'Myanmar',
            alpha3: 'MMR'
          },
          {
            label: 'Namibia',
            alpha3: 'NAM'
          },
          {
            label: 'Nauru',
            alpha3: 'NRU'
          },
          {
            label: 'Nepal',
            alpha3: 'NPL'
          },
          {
            label: 'Netherlands',
            alpha3: 'NLD'
          },
          {
            label: 'New Zealand',
            alpha3: 'NZL'
          },
          {
            label: 'Nicaragua',
            alpha3: 'NIC'
          },
          {
            label: 'Niger',
            alpha3: 'NER'
          },
          {
            label: 'Nigeria',
            alpha3: 'NGA'
          },
          {
            label: 'North Korea',
            alpha3: 'PRK'
          },
          {
            label: 'North Macedonia',
            alpha3: 'MKD'
          },
          {
            label: 'Norway',
            alpha3: 'NOR'
          },
          {
            label: 'Oman',
            alpha3: 'OMN'
          },
          {
            label: 'Pakistan',
            alpha3: 'PAK'
          },
          {
            label: 'Palau',
            alpha3: 'PLW'
          },
          {
            label: 'Palestine, State of',
            alpha3: 'PSE'
          },
          {
            label: 'Panama',
            alpha3: 'PAN'
          },
          {
            label: 'Papua New Guinea',
            alpha3: 'PNG'
          },
          {
            label: 'Paraguay',
            alpha3: 'PRY'
          },
          {
            label: 'Peru',
            alpha3: 'PER'
          },
          {
            label: 'Philippines',
            alpha3: 'PHL'
          },
          {
            label: 'Poland',
            alpha3: 'POL'
          },
          {
            label: 'Portugal',
            alpha3: 'PRT'
          },
          {
            label: 'Qatar',
            alpha3: 'QAT'
          },
          {
            label: 'Romania',
            alpha3: 'ROU'
          },
          {
            label: 'Russian Federation',
            alpha3: 'RUS'
          },
          {
            label: 'Rwanda',
            alpha3: 'RWA'
          },
          {
            label: 'Saint Kitts and Nevis',
            alpha3: 'KNA'
          },
          {
            label: 'Saint Lucia',
            alpha3: 'LCA'
          },
          {
            label: 'Saint Vincent and the Grenadines',
            alpha3: 'VCT'
          },
          {
            label: 'Samoa',
            alpha3: 'WSM'
          },
          {
            label: 'San Marino',
            alpha3: 'SMR'
          },
          {
            label: 'Sao Tome and Principe',
            alpha3: 'STP'
          },
          {
            label: 'Saudi Arabia',
            alpha3: 'SAU'
          },
          {
            label: 'Senegal',
            alpha3: 'SEN'
          },
          {
            label: 'Serbia',
            alpha3: 'SRB'
          },
          {
            label: 'Seychelles',
            alpha3: 'SYC'
          },
          {
            label: 'Sierra Leone',
            alpha3: 'SLE'
          },
          {
            label: 'Singapore',
            alpha3: 'SGP'
          },
          {
            label: 'Slovakia',
            alpha3: 'SVK'
          },
          {
            label: 'Slovenia',
            alpha3: 'SVN'
          },
          {
            label: 'Solomon Islands',
            alpha3: 'SLB'
          },
          {
            label: 'Somalia',
            alpha3: 'SOM'
          },
          {
            label: 'South Africa',
            alpha3: 'ZAF'
          },
          {
            label: 'South Korea',
            alpha3: 'KOR'
          },
          {
            label: 'South Sudan',
            alpha3: 'SSD'
          },
          {
            label: 'Spain',
            alpha3: 'ESP'
          },
          {
            label: 'Sri Lanka',
            alpha3: 'LKA'
          },
          {
            label: 'Sudan',
            alpha3: 'SDN'
          },
          {
            label: 'Suriname',
            alpha3: 'SUR'
          },
          {
            label: 'Sweden',
            alpha3: 'SWE'
          },
          {
            label: 'Switzerland',
            alpha3: 'CHE'
          },
          {
            label: 'Syria',
            alpha3: 'SYR'
          },
          {
            label: 'Tajikistan',
            alpha3: 'TJK'
          },
          {
            label: 'Tanzania',
            alpha3: 'TZA'
          },
          {
            label: 'Thailand',
            alpha3: 'THA'
          },
          {
            label: 'Timor-Leste',
            alpha3: 'TLS'
          },
          {
            label: 'Togo',
            alpha3: 'TGO'
          },
          {
            label: 'Tonga',
            alpha3: 'TON'
          },
          {
            label: 'Trinidad and Tobago',
            alpha3: 'TTO'
          },
          {
            label: 'Tunisia',
            alpha3: 'TUN'
          },
          {
            label: 'Turkey',
            alpha3: 'TUR'
          },
          {
            label: 'Turkmenistan',
            alpha3: 'TKM'
          },
          {
            label: 'Tuvalu',
            alpha3: 'TUV'
          },
          {
            label: 'Uganda',
            alpha3: 'UGA'
          },
          {
            label: 'Ukraine',
            alpha3: 'UKR'
          },
          {
            label: 'United Arab Emirates',
            alpha3: 'ARE'
          },
          {
            label: 'United Kingdom',
            alpha3: 'GBR'
          },
          {
            label: 'United States of America',
            alpha3: 'USA'
          },
          {
            label: 'Uruguay',
            alpha3: 'URY'
          },
          {
            label: 'Uzbekistan',
            alpha3: 'UZB'
          },
          {
            label: 'Vanuatu',
            alpha3: 'VUT'
          },
          {
            label: 'Vatican City',
            alpha3: 'VAT'
          },
          {
            label: 'Venezuela',
            alpha3: 'VEN'
          },
          {
            label: 'Vietnam',
            alpha3: 'VNM'
          },
          {
            label: 'Yemen',
            alpha3: 'YEM'
          },
          {
            label: 'Zambia',
            alpha3: 'ZMB'
          },
          {
            label: 'Zimbabwe',
            alpha3: 'ZWE'
          }
        ]
      },
      expat_project_deductible: [0, 500, 1000, 5000, 10000],
      business_sectors: {
        fr: [
          {
            label: 'Armement',
            key: 899
          },
          {
            label:
              'Artisanat, m\u00e9tiers d\u2019art et commerce de biens culturels',
            key: 900
          },
          {
            label: 'Automobile/Commerce de v\u00e9hicules',
            key: 902
          },
          {
            label: 'B\u00e2timent et travaux publics',
            key: 903
          },
          {
            label: 'Crypto-monnaie/Monnaie \u00e9lectronique',
            key: 904
          },
          {
            label: 'Esp\u00e8ces, transmissions de fonds, change manuel',
            key: 905
          },
          {
            label: 'Financement participatif',
            key: 906
          },
          {
            label: 'Gestion de fortune',
            key: 907
          },
          {
            label: 'H\u00f4tellerie/restauration',
            key: 908
          },
          {
            label: 'Immobilier',
            key: 909
          },
          {
            label: 'Informatique, t\u00e9l\u00e9com',
            key: 910
          },
          {
            label:
              'Jeux/ \u00e9tablissements de jeux/jeux et paris en r\u00e9seau physique et/ou en ligne',
            key: 911
          },
          {
            label:
              'Organismes \u00e0 but non lucratifs (fondations, associations)',
            key: 901
          },
          {
            label:
              'Pierres pr\u00e9cieuses /N\u00e9gociants de m\u00e9taux pr\u00e9cieux et de pierres pr\u00e9cieuses/Horlogerie,bijouterie,joaillerie,orf\u00e8vrerie',
            key: 912
          },
          {
            label: 'Sport/Agent sportif',
            key: 913
          },
          {
            label: 'TODO1',
            key: 511
          },
          {
            label: 'TODO2',
            key: 512
          },
          {
            label: 'Transport logistique',
            key: 914
          },
          {
            label: '\u00a0Autre',
            key: 915
          }
        ],
        en: [
          {
            label: 'Armament',
            key: 899
          },
          {
            label: 'Automotive / vehicle trade',
            key: 902
          },
          {
            label: 'Cash, money transfers, manual currency exchange',
            key: 905
          },
          {
            label: 'Construction and public works',
            key: 903
          },
          {
            label: 'Craftsmanship, fine arts, and cultural goods trade',
            key: 900
          },
          {
            label: 'Crowdfunding',
            key: 906
          },
          {
            label: 'Cryptocurrency / Electronic currency',
            key: 904
          },
          {
            label:
              'Gaming / Gambling establishments / Physical and/or online gaming and betting',
            key: 911
          },
          {
            label: 'Hospitality / catering',
            key: 908
          },
          {
            label: 'IT / Telecommunications',
            key: 910
          },
          {
            label: 'Non-profit organisations (foundations, associations)',
            key: 901
          },
          {
            label:
              'Precious stones/Precious metal and precious stone dealers/Watchmaking, jewelry, goldsmiths and silversmiths',
            key: 912
          },
          {
            label: 'Real estate',
            key: 909
          },
          {
            label: 'Sport / Sports agent',
            key: 913
          },
          {
            label: 'TODO1',
            key: 511
          },
          {
            label: 'TODO2',
            key: 512
          },
          {
            label: 'Transport logistics',
            key: 914
          },
          {
            label: 'Wealth management',
            key: 907
          },
          {
            label: '\u00a0Other',
            key: 915
          }
        ]
      },
      minimum_subscription_period: 8,
      acs_cfe_allowed_nationalities: {
        fr: [
          {
            label: 'France',
            alpha3: 'FRA'
          },
          {
            label: 'Monaco',
            alpha3: 'MCO'
          },
          {
            label: 'Suisse',
            alpha3: 'CHE'
          }
        ],
        en: [
          {
            label: 'France',
            alpha3: 'FRA'
          },
          {
            label: 'Monaco',
            alpha3: 'MCO'
          },
          {
            label: 'Switzerland',
            alpha3: 'CHE'
          }
        ]
      }
    }).pipe(delay(2000));
  }

  public getExpatClientInfos(): Observable<ExpatClient> {
    return of({
      address_1: 'fsdfsdfsdf',
      address_2: '',
      birth_date: '1990-09-08',
      city: 'sdfsdfds',
      country: 'IDN',
      email: 'a@b.fr',
      first_name: 'Jeanne',
      language: 'fr',
      last_name: 'DELAPLANCHE',
      phone: '+33123456789',
      postal_code: '34654',
      terms_accepted: true,
      data_consent_commercial: false,
      title: 'Madame'
    }).pipe(delay(2000));
  }

  public getProjectByUuid(): Observable<ExpatProject> {
    return of<ExpatProject>({
      beneficiaries: [
        {
          acs_expat_beneficiary_business_sector: 0,
          acs_expat_beneficiary_email: '',
          acs_expat_beneficiary_maternity_option: 0,
          acs_expat_beneficiary_nationality_country: 'DZA',
          acs_expat_beneficiary_occupation: '',
          acs_expat_beneficiary_ppe: false,
          birth_date: '2007-10-17T00:00:00.000Z',
          category: 'Conjoint',
          first_name: '',
          last_name: ''
        },
        {
          acs_expat_beneficiary_business_sector: 4,
          acs_expat_beneficiary_email: 'a@b.fr',
          acs_expat_beneficiary_maternity_option: 1,
          acs_expat_beneficiary_nationality_country: 'DZA',
          acs_expat_beneficiary_occupation: '',
          acs_expat_beneficiary_ppe: false,
          birth_date: '1990-09-08T00:00:00.000Z',
          category: 'Souscripteur',
          first_name: 'Jeanne',
          last_name: 'DELAPLANCHE'
        }
      ],
      pricing: {
        effect_date: '2025-10-25T00:00:00Z',
        expat_project_additional_country: null,
        expat_project_assistance_plus_option: null,
        expat_project_country: 'ZAF',
        expat_project_cover_nationality_country: 'Non',
        expat_project_deductible: 0,
        expat_project_dental_and_optical_option: 2,
        expat_project_maternity_option: 1,
        expat_project_medical_care_option: 2,
        expat_project_nationality: 'DZA',
        expat_project_payment_method_choice: 'Prélèvement SEPA',
        expat_project_periodicity_choice: 4,
        expat_project_plan: 'Gold'
      },
      product: 'expat_eur',
      client: {
        address_1: 'fsdfsdfsdf',
        address_2: '',
        birth_date: '1990-09-08',
        city: 'sdfsdfds',
        country: 'IDN',
        email: 'a@b.fr',
        first_name: 'Jeanne',
        language: 'fr',
        last_name: 'DELAPLANCHE',
        phone: '+33123456789',
        postal_code: '34654',
        terms_accepted: true,
        data_consent_commercial: false,
        title: 'Madame'
      }
    }).pipe(delay(2000));
  }

  public postExpatTarificationCalculate(): Observable<ExpatPricing> {
    return of<ExpatPricing>({
      periodicity_pricing: {
        annual: 7505.09,
        monthly: 625.42,
        semi_annual: 3752.52,
        quarterly: 1876.26
      },
      association_membership_fee: 20,
      already_covered_in_origin_country: 'Oui',
      coverage_zone: {
        fr: 'Monde entier sauf \nAfghanistan, Afrique du Sud, Arabie Saoudite, Australie, Bahamas, Bahre\u00efn, Br\u00e9sil, Brunei Darussalam, Canada, Chine, Cor\u00e9e du Nord, Emirats Arabes Unis, Etats-Unis, Hong Kong, Iran, Isra\u00ebl, Japon, Kowe\u00eft, Maroc, Mexique, Nouvelle-Z\u00e9lande, Oman, Qatar, Royaume-Uni, Russie, Singapour, Soudan du sud, Suisse, Syrie.\n\nSont couverts, en dehors de la zone de couverture choisie (\u00e0 l\u2019exception de Afghanistan, Cor\u00e9e du Nord, Iran, Syrie), lors d\u2019un d\u00e9placement d\u2019une dur\u00e9e de moins de sept (7) semaines, les seuls frais cons\u00e9cutifs \u00e0 un accident ou une maladie pr\u00e9sentant un caract\u00e8re d\u2019urgence.\n\n',
        en: 'Worldwide except \nAfghanistan, Australia, Bahamas, Bahrain, Brazil, Brunei, Canada, China, Hong Kong, Iran, Israel, Japan, Kuwait, Mexico, Morocco, New Zealand, North Korea, Oman, Qatar, Russia, Saudi Arabia, Singapore, South Africa, South Sudan, Switzerland, Syria, United Arab Emirates, United Kingdom, United States of America.\n\nAre covered, outside the selected zone of coverage (except Afghanistan, Iran, North Korea, Syria), during a trip of less than seven (7) weeks, expenses only arising from an accident or a medical emergency.\n\n'
      }
    }).pipe(delay(2000));
  }

  public getInfoForNewProjectForSameClient(): Observable<TokenResponse> {
    return of({
      token: 'token_projet_nouveau_projet_meme_client',
      token_producer: 'token_apporteur'
    }).pipe(delay(2000));
  }

  public  postStep2(): Observable<TokenResponse> {
    return of({
      token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJtb2R1bHIiLCJuYmYiOjE3NjE2NTc0NzEsImlhdCI6MTc2MTY1NzQ3MSwic3ViIjoiZ3VpZC1hY2Nlc3MiLCJleHAiOjE3NjE2NjQ2NzEsImVudGl0eSI6ImNsaWVudHMiLCJ1dWlkIjoiNjVhZGMyMzQtMjI5OC00ODQ0LTljMTQtNzQzZDM0ZDIwZTdjIn0.UUuJ5bBAlnS5S0CabatNVPsKkcN06IPlPu2eG957fO0&uuid=65adc234-2298-4844-9c14-743d34d20e7c',
      token_producer: 'token_producer'
    }).pipe(delay(2000));
  }

  public postStep3Subscribe(): Observable<TokenResponse> {
    return of({
      token: 'token_client_ou_projet',
      token_producer: 'token_producer'
    }).pipe(delay(2000));
  }

  public postStep3Save(): Observable<TokenResponse> {
    return of({
      token: 'token_client_ou_projet',
      token_producer: 'token_producer'
    }).pipe(delay(2000));
  }

  public postStep4(): Observable<TokenResponse> {
    return of({
      token: 'token_client_ou_projet',
      token_producer: 'token_producer'
    }).pipe(delay(2000));
  }
}
